// @flow
import StatementEditForm, { type FormData } from './StatementEditForm';

export default StatementEditForm;
export type { FormData };
